import { get, post } from "../../helpers/apiWrapper";

export const getAssessments = async (params) => {
  const config = {
    params: params,
  };
  return await get(`/assessments`, config);
};

export const verifyAssessment = async (verifyCode) => {
  const config = {
    data: verifyCode,
  };
  return await post(`/verify-assessment-code`, config);
};

export const resendAssessment = async (verifyCode) => {
  const config = {
    data: verifyCode,
  };
  return await post(`/resend-assessment-code`, config);
};

export const assessmentDetails = async (assesmentName) => {
  const config = {
    data: assesmentName,
  };
  return await post(`/assessment-details`, config);
};

export const startExam = async (assesmentData) => {
  const config = {
    data: assesmentData,
  };
  return await post(`/start-exam`, config);
};

export const examDetails = async (examData) => {
  const config = {
    data: examData,
  };
  return await post(`/exam-details`, config);
};

export const saveExamAnswer = async (saveExamData) => {
  const config = {
    data: saveExamData,
  };
  return await post(`/save-exam-answer`, config);
};
